import { render, staticRenderFns } from "./Linha2.vue?vue&type=template&id=5392a2c8&scoped=true&"
import script from "./Linha2.vue?vue&type=script&lang=js&"
export * from "./Linha2.vue?vue&type=script&lang=js&"
import style0 from "./Linha2.vue?vue&type=style&index=0&id=5392a2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5392a2c8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5392a2c8')) {
      api.createRecord('5392a2c8', component.options)
    } else {
      api.reload('5392a2c8', component.options)
    }
    module.hot.accept("./Linha2.vue?vue&type=template&id=5392a2c8&scoped=true&", function () {
      api.rerender('5392a2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/components/Linha2.vue"
export default component.exports